/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import AppView from "../../../app.view";


export class AppContextType {
    constructor (public app: AppView) {}
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const useAppContext = (): AppContextType => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the AppContext");
    }
    return context;
};